module.exports = __webpack_public_path__ + "img/jingpin.315b50d5.png";